export default __webpack_public_path__ + "static/media/whoops.9c193e09.png";